import { jsx as _jsx } from "react/jsx-runtime";
import { useCategoryStore } from '../../../../store/category';
import { useGlobalStore } from "@/store/global";
export default function AttributeRadio({ attribute, updateVariantValues }) {
    const settings = useGlobalStore((state) => state.config.template_settings);
    const filter = useCategoryStore((state) => state.filter.attributes);
    const setFilter = useCategoryStore((state) => state.setFilter);
    const valueAttribute = filter.find((item) => item.id === attribute.id);
    const replace = settings.category.allow_only_one_value_in_radio_filter.enabled;
    return (_jsx("div", { className: "values emulated-flex-gap", children: attribute.values.map((value) => (_jsx("button", { name: `attribute-${attribute.id}-value-${value.id}`, onClick: () => {
                setFilter({ selectedValue: { attribute, value }, replace: replace });
                updateVariantValues(attribute, value);
            }, type: 'button', className: `${valueAttribute?.values.includes(value.id) ? 'active' : ''}`, children: value.value }, `attribute-${attribute.id}-value-${value.id}`))) }));
}
